import { AuthenticationContainer, StyledLoginFormContainer } from "../../components";
import type { AuthenticationRequestData } from "../../schemas";

import { PasswordResetForm } from "./password-reset-form";

export interface PasswordResetTemplateProps {
	readonly onSubmit: (data: AuthenticationRequestData) => void;
	readonly defaultUsername: string;
	readonly isError: boolean;
}

export const PasswordResetTemplate: React.FC<PasswordResetTemplateProps> = ({ onSubmit, defaultUsername, isError }) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<PasswordResetForm onSubmit={onSubmit} defaultUsername={defaultUsername} isError={isError} />
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
